import megatron from 'megatron';

import {allFirstLevelObjectKeysAreNonNullable} from '../../../utils/common-utils';

import {detailsAPIEndPoints, __GOIBIBO__, __MYPARTNER__} from '../../../config/api-config';

export interface HotelPolicyDataTypes {
  additional_hotel_policy: {
    'Hotel Policy': Array<any>;
  };
  hotelPolicy: string[];
}

type ReturnType = [
  {
    hotelPolicyList: string[];
    additionalData: any;
  },
  Error,
];

const fetchHotelPolicy = async options => {
  const {checkin, checkout, pax, cityId, hotelCode, forwardParams, vendor} = options;

  if (!allFirstLevelObjectKeysAreNonNullable(options)) {
    return [
      {
        hotelPolicyList: [],
        additionalData: {},
      },
      new Error('Something Went Wrong While Fetching Hotel Policy. Please Try Refreshing'),
    ] as ReturnType;
  }

  const strQry = `hotels-${cityId}-${checkin}-${checkout}-${pax}`;

  const url = `${__MYPARTNER__}/${
    detailsAPIEndPoints.hotelPolicy
  }&strQry=${strQry}&hc=${hotelCode}&fwdParams=${JSON.stringify(forwardParams)}&v=${vendor ||
    'v3'}`;

  let error: null | Error = null;

  let hotelPolicyData = {
    hotelPolicyList: [],
    additionalData: {},
  };

  try {
    const response = await megatron({
      name: 'hotelPolicy',
      type: 'GET',
      credentials: 'omit',
      url,
    });

    if (response) {
      hotelPolicyData = {
        ...hotelPolicyData,
        ...(response.hotelPolicy ? {hotelPolicyList: response.hotelPolicy} : {}),
        ...(response.additional_hotel_policy
          ? {additionalData: response.additional_hotel_policy}
          : {}),
      };
    }
  } catch (e) {
    error = e;
  }

  return [hotelPolicyData, error] as ReturnType;
};

export default fetchHotelPolicy;
